// UserContext.js
import React, { createContext, useState } from 'react';

export const UserContext = createContext({
  usuario: null,
  setUsuario: () => {},
});

export const UserProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(
    JSON.parse(localStorage.getItem('user')) || null
  );

  return (
    <UserContext.Provider value={{ usuario, setUsuario }}>
      {children}
    </UserContext.Provider>
  );
};
